const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "AAIC_RETRIEVED":
            return action.accountingAuthorityIdentificationCodes;

        default:
            return state;
    }
}
